import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import LocalFileFormInput from '../../form/input/LocalFile';
import RepositoryUploadSnackbar from './RepositoryUploadSnackbar';
import DataAction from '../../data/actions';
import FormError from '../../form/Error';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import getHumanFileSize from '../../utils/formatting/getHumanFileSize';
var useStyles = makeStyles({
  error: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0
  }
}, {
  name: 'ECRepositoryUpload'
});
/**
 * @param {import('./types').RepositoryUploadProps} props
 */

function RepositoryUpload(_ref) {
  var workspace = _ref.workspace,
      path = _ref.path,
      onSuccess = _ref.onSuccess,
      onError = _ref.onError,
      maxSize = _ref.maxSize,
      optimizeImageWeb = _ref.optimizeImageWeb,
      widthHeightMaxLimit = _ref.widthHeightMaxLimit,
      rest = _objectWithoutProperties(_ref, ["workspace", "path", "onSuccess", "onError", "maxSize", "optimizeImageWeb", "widthHeightMaxLimit"]);

  var classes = useStyles({});

  var _React$useState = React.useState({
    files: null,
    status: {
      response: '',
      error: ''
    }
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      filesData = _React$useState2[0],
      setFilesData = _React$useState2[1];

  var _React$useState3 = React.useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      error = _React$useState4[0],
      setError = _React$useState4[1];

  var showError = function showError(message) {
    setError(message);
    setTimeout(function () {
      return setError(null);
    }, 5000);
  };

  var onChange = function onChange(acceptedFiles) {
    var multi = acceptedFiles instanceof Array;
    if (multi && acceptedFiles.length === 0 || !acceptedFiles) return showError("Unable to upload one or more files due to invalid types.");

    if (maxSize !== undefined) {
      var sizeExceedingFiles = acceptedFiles.filter(function (file) {
        return file.size > maxSize;
      });

      if (sizeExceedingFiles.length > 0) {
        showError("Couldn't upload ".concat(sizeExceedingFiles.length, " files, maximum size allowed is ").concat(getHumanFileSize(maxSize), "."));
      }

      acceptedFiles = acceptedFiles.filter(function (file) {
        return !sizeExceedingFiles.includes(file);
      });
      if (acceptedFiles.length === 0) return;
    }

    setFilesData({
      files: acceptedFiles,
      status: {
        response: 'uploading',
        error: ''
      }
    });
    DataAction.item({
      dataType: 'repository',
      dataProps: {
        type: 'file'
      }
    }).create({
      workspace: workspace,
      folderPath: path,
      optimizeImageWeb: optimizeImageWeb,
      widthHeightMaxLimit: widthHeightMaxLimit,
      files: acceptedFiles instanceof Array ? acceptedFiles : [acceptedFiles]
    }).then(function (action) {
      var status = null;

      if (!action.failed) {
        status = {
          response: 'succeeded'
        };
        if (typeof onSuccess === 'function') onSuccess();
      } else {
        status = {
          response: 'failed',
          error: action.payload.text
        };
        if (typeof onError === 'function') onError(action.payload);
      }

      setFilesData(function (prevState) {
        return _objectSpread({}, prevState, {
          status: status
        });
      });
    });
  };

  return React.createElement("div", null, React.createElement(LocalFileFormInput, Object.assign({
    onChange: onChange
  }, rest)), React.createElement(RepositoryUploadSnackbar, {
    files: filesData.files,
    status: filesData.status
  }), error && React.createElement(Grid, {
    container: true,
    justify: "center",
    className: classes.error
  }, React.createElement(Grid, {
    item: true
  }, React.createElement(FormError, null, error))));
}

RepositoryUpload.defaultProps = {
  path: ''
};
export default RepositoryUpload;